import React, {Component} from 'react';

class HairServicesLearnMore extends Component {
    constructor(props){
        super(props)
        this.activePopupHair = this.activePopupHair.bind(this);

    }

    activePopupHair() {
        this.props.handlePopupHair(false)
    }

    render() {
        return (
            <div id="popup-hair" className="slickModal isActive"
                 style={{"transition-duration": "0.4s"}}>
                <div className="slickOverlay closeModal setSlickCookie"
                     style={{'background': 'rgba(0, 0, 0, 0.85098)', 'transition-duration': '0.4s'}}></div>
                <div className="slickWindow center animated" style={{
                    'width': '320px',
                    'height': '500px',
                    'box-shadow': 'rgba(0, 0, 0, 0.4) 0px 0px 20px 0px',
                    'background': 'rgb(255, 255, 255)',
                    'border-radius': '0px',
                    'margin': 'auto',
                    'padding': '0px',
                    'animation-duration': '0.4s',
                    'animation-delay': '0.2'
                }}>
                    <div className="slickCloseBtn close closeModal icon"
                         onClick={this.activePopupHair}
                    ></div>
                    <div className="wrap">
                        <div className="popup-icon"></div>

                        <h2>Hair Services</h2>

                        <div className="stylulist">
                            <strong>Blowout</strong>- From wet to dry,simply straight or full and voluminous
                            <em>Duration: 45 mins</em>
                        </div>
                        <div className="stylulist">
                            <strong>Blowout+Dry Style:</strong> Includes one blowout from wet to dry. Then hot tools
                            are
                            used- curls,waves or flat iron.
                            <em>Duration: 1 Hour</em>
                        </div>
                        <div className="stylulist">
                            <strong>Updo:</strong> Any updo or half/down from a high sleek pony, undone chignon, or
                            a
                            bohemian inspired braid.
                            <em>Duration: 1 Hour</em>
                        </div>
                        <div className="stylulist">
                            <strong>Mens Cut:</strong> Includes any preferred haircut+style.
                            <em>Duration: 45 Mins</em>
                        </div>
                        <div className="stylulist">
                            <strong>Clip-in extensions:</strong> $25
                            <em>(additional charge for styling)</em>
                        </div>
                    </div>
                </div>
                <div className="cta" style={{'display': 'none'}}>
                    <span className="closeModal">Close me</span>
                </div>
            </div>
        )
    }
}

export default HairServicesLearnMore;


/** WEBPACK FOOTER **
 ** ./src/components/HairServicesLearnMore.js
 **/